// extracted by mini-css-extract-plugin
export default {"disabledButtonWrapper":"DemandForecastCell_disabledButtonWrapper__XRlBO","disabledButton":"DemandForecastCell_disabledButton__30y4K"};